import Image, { StaticImageData } from "next/image";
import { PropsWithChildren } from "react";

export default function Company({
  name,
  logo,
  diagram,
  children,
}: PropsWithChildren<{
  name: string;
  logo: StaticImageData;
  diagram?: StaticImageData;
}>) {
  return (
    <aside>
      <div>
        <a
          href={`https://${name.replace(" ", "").toLowerCase()}.com`}
          target="_blank"
          rel="noreferrer noopener"
        >
          <Image
            src={logo}
            objectFit="contain"
            objectPosition="left center"
            alt={`${name} logo`}
          />
        </a>
      </div>
      <div>{children}</div>
      {diagram && (
        <div className="diagram">
          <Image src={diagram} alt="Diagram" />
        </div>
      )}
      <style jsx>{`
        div {
          padding-block: 24px;
          border-top: 1px dashed var(--color-core-cobalt);
        }
        div:last-child {
          border-bottom: 1px dashed var(--color-core-cobalt);
        }
        a {
          display: block;
          line-height: 0;
        }
        a > :global(span) {
          height: 48px !important;
          max-width: min(66%, 200px) !important;
        }
        aside :global(p) {
          font-weight: 600;
          font-size: 18px;
          line-height: 27px;
          color: var(--color-deep-cobalt);
          letter-spacing: 0;
        }
        .diagram {
          padding: 24px 0;
        }
        @media (max-width: 520px) {
          aside {
            grid-row: 4;
            padding-inline: 16px;
            margin-block: 48px;
          }
          aside :global(p) {
            padding-right: 8px;
          }
          .diagram:last-child {
            background: #f3f7ff;
            margin: 32px -32px;
            padding: 24px;
            border: 0;
          }
        }
        @media (min-width: 820px) {
          aside {
            margin-top: -16px;
          }
        }
      `}</style>
    </aside>
  );
}
